export default __webpack_public_path__ + "static/media/GregoryPluijm.9931a57d.png";